import React from "react";

export default function Card({ children }) {
  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg flex-grow-0" style={{ backgroundColor: "var(--content-item-bg)", color: "var(--main-font-color)" }}>
      {children}
    </div>
  );
}
